const Welcome = () => import('~/pages/welcome').then(m => m.default || m)

const Dashboard = () => import('~/pages/dashboard/index').then(m => m.default || m)
const Login = () => import('~/pages/auth/login').then(m => m.default || m)
const Register = () => import('~/pages/auth/register').then(m => m.default || m)
const PasswordEmail = () => import('~/pages/auth/password/email').then(m => m.default || m)
const PasswordReset = () => import('~/pages/auth/password/reset').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)

const Profile = () => import('~/pages/profile/index').then(m => m.default || m)


const FilteringProfile = () => import('~/pages/front/filtering-profile').then(m => m.default || m)


const Devices = () => import('~/pages/devices/index').then(m => m.default || m)
const ViewActivity = () => import('~/pages/devices/ViewActivity').then(m => m.default || m)
const ViewFilteringProfile = () => import('~/pages/devices/ViewFilteringProfile').then(m => m.default || m)
// const ViewPublicFilteringProfile = () => import('~/pages/devices/ViewPublicFilteringProfile').then(m => m.default || m)
const CustomizeFilteringProfile = () => import('~/pages/devices/CustomizeFilteringProfile').then(m => m.default || m)
const PublicCustomizeFilteringProfile = () => import('~/pages/devices/PublicCustomizeFilteringProfile').then(m => m.default || m)
const ViewRequests = () => import('~/pages/devices/ViewRequests').then(m => m.default || m)
const DevicesAndroid = () => import('~/pages/devices/android').then(m => m.default || m)
const DevicesIos = () => import('~/pages/devices/ios').then(m => m.default || m)
const DevicesBlackberry = () => import('~/pages/devices/blackberry').then(m => m.default || m)
const DevicesIc= () => import('~/pages/devices/ic_profile').then(m => m.default || m)
const DevicesInet= () => import('~/pages/devices/inet').then(m => m.default || m)

const BillingInfo= () => import('~/pages/billing_info/index').then(m => m.default || m)

const InvoicesPage= () => import('~/pages/invoices/page').then(m => m.default || m)
const InvoicesIndex= () => import('~/pages/invoices/index').then(m => m.default || m)
const InvoicesShow= () => import('~/pages/invoices/id').then(m => m.default || m)

const Support= () => import('~/pages/support/index').then(m => m.default || m)
// const Blog= () => import('~/pages/blog/index').then(m => m.default || m)
const Tickets= () => import('~/pages/support/create_a_ticket').then(m => m.default || m)
const Call= () => import('~/pages/support/call_number').then(m => m.default || m)

const SignUp= () => import('~/pages/dashboard/sign_up').then(m => m.default || m)
const Features= () => import('~/pages/dashboard/features').then(m => m.default || m)
const PrivacyPolicy= () => import('~/pages/dashboard/privacy_policy').then(m => m.default || m)
const RefundPolicy= () => import('~/pages/dashboard/refund_policy').then(m => m.default || m)
const Status= () => import('~/pages/dashboard/status').then(m => m.default || m)
const Calendar= () => import('~/pages/dashboard/calendar').then(m => m.default || m)
const HelpCenter= () => import('~/pages/dashboard/help_center').then(m => m.default || m)
const Feedback= () => import('~/pages/dashboard/feedback').then(m => m.default || m)
const Blog= () => import('~/pages/dashboard/blog').then(m => m.default || m)
const ReportWebsite= () => import('~/pages/dashboard/report_a_website').then(m => m.default || m)
const ShowTickets= () => import('~/pages/tickets/index').then(m => m.default || m)
const ViewTicket= () => import('~/pages/tickets/view_ticket').then(m => m.default || m)

//admin
const Users = () => import('~/pages/admin/users/index').then(m => m.default || m)

const AdminUsers = () => import('~/pages/admin/admin_users/index').then(m => m.default || m)
const AddAdminUser = () => import('~/pages/admin/admin_users/add_user').then(m => m.default || m)
const EditAdminUser = () => import('~/pages/admin/admin_users/edit_user').then(m => m.default || m)
const EmailTemplate = () => import('~/pages/admin/email_template/index').then(m => m.default || m)
const EditEmailTemplate = () => import('~/pages/admin/email_template/edit_email_template').then(m => m.default || m)
const AdminTickets = () => import('~/pages/admin/tickets/index').then(m => m.default || m)
const AdminTicketReplyTemplates = () => import('~/pages/admin/tickets/templates').then(m => m.default || m)
const EditTicketReplyTemplate = () => import('~/pages/admin/tickets/edit_reply_template').then(m => m.default || m)
const ViewAdminTicket = () => import('~/pages/admin/tickets/view_ticket').then(m => m.default || m)
const BillingInfoRequest = () => import('~/pages/admin/billing_info/index').then(m => m.default || m)
const ViewBillingInfoRequest = () => import('~/pages/admin/billing_info/view_requests').then(m => m.default || m)

export default [
    {path: '/', name: 'dashboard', component: Dashboard},

    {path: '/login', name: 'login', component: Login},
    {path: '/register/', name: 'register', component: Register},
    {path: '/register/:id', name: 'register', component: Register},
    {path: '/password/reset', name: 'password.request', component: PasswordEmail},
    {path: '/password/reset/:token', name: 'password.reset', component: PasswordReset},


    {path: '/filtering-profile', name: 'filtering-profile', component: FilteringProfile},



    {
        path: '/profile',
        name: 'profile',
        component: Profile,
    },

    // {
    //     path: '/devices',
    //     component: Devices,
    //     children: [
    //         {path: '', redirect: {name: 'devices.android'}},
    //         {path: 'android', name: 'devices.android', component: DevicesAndroid},
    //         {path: 'ios', name: 'devices.ios', component: DevicesIos},
    //         {path: 'blackberry', name: 'devices.blackberry', component: DevicesBlackberry},
    //         {path: 'ic', name: 'devices.ic', component: DevicesIc},
    //         {path: 'inet', name: 'devices.inet', component: DevicesInet},
    //     ]
    // },

    {
        path: '/devices',
        component: Devices,
        children: [
            {path: '', name: 'devices', component: Devices},
            // {path: '/devices/activity/:id', name: 'device.activity', component: ViewActivity, props: true},
        ]
    },

    {path: '/devices/activity/:id', name: 'device.activity', component: ViewActivity, props: true},
    {path: '/devices/filtering_profile/:id', name: 'filtering.profile', component: ViewFilteringProfile, props: true},
    // {path: '/devices/public/filtering_profile/:id', name: 'public.filtering.profile', component: ViewPublicFilteringProfile, props: true},
    {path: '/devices/filtering_profile_customize/:id', name: 'filtering.customize', component: CustomizeFilteringProfile, props: true},
    {path: '/devices/public/filtering_profile_customize/:id', name: 'filtering.customize', component: PublicCustomizeFilteringProfile, props: true},
    {path: '/devices/requests/:id', name: 'device.requests', component: ViewRequests, props: true},

    {
        path: '/billing-info',
        component: BillingInfo,
        children: [
            {path: '', name: 'billing-info', component: BillingInfo},
        ]
    },

    {
        path: '/transactions',
        component: InvoicesPage,
        children: [
            {path: '', name: 'invoices', component: InvoicesIndex},
            {path: ':id', name: 'invoices.id', component: InvoicesShow, props: true},
        ]
    },

    {
        path: '/support',
        component: Support,
        children: [
            {path: '', name: 'support', component: Support},
        ]
    },

    // { path: '/welcome', name: 'welcome', component: Welcome },

    {path: '/tickets/add', name: 'tickets', component: Tickets},
    {path: '/call', name: 'call', component: Call},
    // {path: '/blog', name: 'blog', component: Blog},

    {path: '/sign-up', name: 'sign-up', component: SignUp},
    {path: '/features', name: 'features', component: Features},
    {path: '/privacy-policy', name: 'privacy-policy', component: PrivacyPolicy},
    {path: '/refund-policy', name: 'refund-policy', component: RefundPolicy},
    {path: '/status', name: 'server-status', component: Status},
    {path: '/calendar', name: 'calendar', component: Calendar},
    {path: '/help-center', name: 'help-center', component: HelpCenter},
    {path: '/feedback', name: 'feedback', component: Feedback},
    {path: '/blog', name: 'blog', component: Blog},
    {path: '/report', name: 'report-website', component: ReportWebsite},
    {path: '/tickets', name: 'show-tickets', component: ShowTickets},
    {path: '/tickets/:id', name: 'view-ticket', component: ViewTicket},

    {path: '*', component: NotFound},

    //admin
    {path: '/admin/users', name: 'users', component: Users},

    {path: '/admin/admin-users', name: 'admin-users', component: AdminUsers},
    {path: '/admin/admin-users/add', name: 'add-admin-user', component: AddAdminUser},
    {path: '/admin/admin-users/edit/:id', name: 'edit-admin-user', component: EditAdminUser},

    {path: '/admin/email-template', name: 'email-template', component: EmailTemplate},
    {path: '/admin/edit-email-template/:id', name: 'edit-email-template', component: EditEmailTemplate},

    {path: '/admin/ticket-reply-templates', name: 'ticket-reply-templates', component: AdminTicketReplyTemplates},
    {path: '/admin/edit-ticket-reply-template/:id', name: 'edit-ticket-reply-template', component: EditTicketReplyTemplate},
    {path: '/admin/get-ticket-reply-template/:id', name: 'get-ticket-reply-template', component: EditTicketReplyTemplate},

    {path: '/admin/tickets', name: 'admin-tickets', component: AdminTickets},
    {path: '/admin/tickets/:id', name: 'view-admin-ticket', component: ViewAdminTicket},

    {path: '/admin/billing-info-request', name: 'billing-info-request', component: BillingInfoRequest},
    {path: '/admin/view-request-information/:id', name: 'view-request-information', component: ViewBillingInfoRequest},


]



// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js